import React from 'react'
import { AnglePlanBadge } from 'react-angle-dashboard-components'
import { EmployeePlanDetails } from '../../../interfaces/employee'
import { InnerTableSubheader, InnerTableCell, InnerTableText } from './styles'

export const PlanDetailsRow: React.FC<{ plan: EmployeePlanDetails }> = ({
  plan
}) => {
  return (
    <tr className="border-top">
      <InnerTableCell />
      <td style={{ verticalAlign: 'center', padding: '10px 20px' }}>
        <AnglePlanBadge metalTier={plan.tier} />
        <span style={{ fontSize: 16, fontWeight: 500, marginLeft: 8 }}>
          {plan?.planName}
        </span>
      </td>
      <InnerTableCell>
        <InnerTableSubheader>Employee</InnerTableSubheader>
        <InnerTableSubheader>Spouse/Dep</InnerTableSubheader>
        <InnerTableSubheader>Total</InnerTableSubheader>
      </InnerTableCell>
      <InnerTableCell>
        <InnerTableText>
          $<span>{Math.round(plan.employerPremiumEmployee)}</span>
        </InnerTableText>
        <InnerTableText>
          $<span>{Math.round(plan.employerPremiumDependent)}</span>
        </InnerTableText>
      </InnerTableCell>
      <InnerTableCell>
        <InnerTableText>
          {' '}
          $<span>{Math.round(plan.employeePremiumEmployee)}</span>
        </InnerTableText>
        <InnerTableText>
          {' '}
          $<span>{Math.round(plan.employeePremiumDependent)}</span>
        </InnerTableText>
      </InnerTableCell>
      <InnerTableCell>
        <InnerTableText>
          {' '}
          $<span>{Math.round(plan.totalPremiumEmployee)}</span>
        </InnerTableText>
        <InnerTableText>
          {' '}
          $<span>{Math.round(plan.totalPremiumDependent)}</span>
        </InnerTableText>
        <InnerTableText className="font-weight-bold">
          {' '}
          $<span>{Math.round(plan.totalPremium)}</span>
        </InnerTableText>
      </InnerTableCell>
    </tr>
  )
}
